import useSubmitBtns from './useSubmitBtns'
import useAlert from './useAlert'
import useFormFields from './useFormFields'
import useRestForm from './useRestForm'

export default { useFormFields, useRestForm, useSubmitBtns, useAlert }